// venueAgent — the host's voice agent in the room you are in, shared between
// the three places that touch it (2026-10-31, AGENT MODE: API sockets/
// venueMingle). Plain module state, like cafeArtists: nothing re-renders for it.
//
//   components/VenueAgent   owns the call; keeps `on`, `opening`, `speaking`,
//                           `say` and `queue` current
//   components/VenueStage   reads `speaking` (the set ducks, the face moves) and
//                           writes `micNow` (their words into the mic: cues wait)
//                           and `activeAt` (you moved or looked around)
//   components/PlayerBar    venueAgentTake(text): what you type goes to the agent
export const venueAgent = {
  place: null, a: null,
  on: false, opening: false, speaking: false,
  say: null,          // (text) => boolean, while the call is open
  queue: [],          // typed while it was opening: sent when it opens, or answered the recorded way
  micNow: false,
  activeAt: Date.now(),
};

/**
 * What you typed, for the host's agent: true when the agent has it (or will,
 * the moment it opens), so the server keeps it as context and does not answer
 * it again (sendSay `viaAgent`). False: no agent here, it goes the usual way.
 */
export function venueAgentTake(text) {
  const t = String(text || '').trim();
  if (!t) return false;
  venueAgent.activeAt = Date.now();
  if (venueAgent.on && venueAgent.say) return !!venueAgent.say(t);
  if (venueAgent.opening) { venueAgent.queue.push(t); return true; }
  return false;
}
